export { default } from './B2CPostTemplate';
export * from './B2CPostTemplate.types';
export { SidebarWrapper } from './B2CPostTemplate';
